import './ProductSearchResults.css';
import ProductThumbnailsForSearch from '../ProductThumbnailsForSearch/ProductThumbnailsForSearch';

const ProductSearchResults = ({ data, loading }) => {

    function formatNumber(n, p, ts, dp) {
        var t = [];
        // Get arguments, set defaults
        if (typeof p == 'undefined') p = 2;
        if (typeof ts == 'undefined') ts = '.';
        if (typeof dp == 'undefined') dp = ',';

        // Get number and decimal part of n
        n = Number(n).toFixed(p).split('.');

        // Add thousands separator and decimal point (if requied):
        for (var iLen = n[0].length, i = iLen ? iLen % 3 || 3 : 0, j = 0; i <= iLen; i += 3) {
            t.push(n[0].substring(j, i));
            j = i;
        }
        // Insert separators and return result
        return t.join(ts) + (n[1] ? dp + n[1] : '');
    }

    const handleButtonCariKeywordLain = () => {
        const searchBar = document.getElementById("searchbar-input");
        searchBar.style.border = "3px solid #0476D0";
        searchBar.focus();
    }

    return (
        <div className="productsearchresults-wrapper">
            {
                loading ? 
                data.length == 0 ?
                    <div className="product-not-found-notification">
                        <h2>Produk tidak ditemukan.</h2>
                        <div onClick={handleButtonCariKeywordLain}>Coba keyword lain?</div>
                    </div>
                    :
                    data.map(x => {
                        return (
                            <ProductThumbnailsForSearch
                                key={x.id}
                                id={x.id}
                                imageUrl={x.imageUrl}
                                productName={
                                    x.name.length > 20 ?
                                        x.name.substring(0, 15) + "..."
                                        :
                                        x.name
                                }
                                price={formatNumber(x.price, 0)}
                            />
                        )
                    })
                :
                <div className="loader-wrapper">
                    <div className="loader"></div>
                </div>
            }
        </div>
    )
};

export default ProductSearchResults;